// خدمة لجلب بيانات لوحة التحكم
import axiosInstance from '../config/axios';

// إضافة الـ token لكل الطلبات
axiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    console.error('Request error:', error);
    return Promise.reject(error);
});

// خدمة لوحة التحكم
const dashboardService = {
  // جلب جميع بيانات لوحة التحكم في طلب واحد
  getDashboardData: async () => {
    try {
      const response = await axiosInstance.get('/api/admin/dashboard/all');
      return response.data;
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
      throw error;
    }
  }
};

export default dashboardService;
